var LocalStorage;
(function (LocalStorage) {
    LocalStorage["ACCESS_TOKEN"] = "Dango.accessToken";
    LocalStorage["TENANT_ID"] = "Dango.tenantId";
})(LocalStorage || (LocalStorage = {}));
var UserDataSource = (function () {
    function UserDataSource() {
    }
    UserDataSource.setToken = function (token) {
        if (!token) {
            localStorage.removeItem(LocalStorage.ACCESS_TOKEN);
            return undefined;
        }
        localStorage.setItem(LocalStorage.ACCESS_TOKEN, token);
        return token;
    };
    UserDataSource.getTenantId = function () {
        var token = localStorage.getItem(LocalStorage.TENANT_ID);
        if (!token) {
            return undefined;
        }
        return token;
    };
    UserDataSource.setTenantId = function (tenantId) {
        localStorage.setItem(LocalStorage.TENANT_ID, tenantId);
        if (!tenantId) {
            localStorage.removeItem(LocalStorage.TENANT_ID);
            return undefined;
        }
        return tenantId;
    };
    UserDataSource.clearStorage = function () {
        localStorage.clear();
    };
    UserDataSource.getToken = function () {
        var token = localStorage.getItem(LocalStorage.ACCESS_TOKEN);
        if (!token) {
            return undefined;
        }
        return token;
    };
    return UserDataSource;
}());
export { UserDataSource };
export default UserDataSource;
